import { Reveal } from "@/components/Reveal";
import { SectionHeader } from "@/components/SectionHeader";
import { TIMELINE } from "@/data/content";
import { Flag } from "lucide-react";

const NODE_STYLES = {
    past: "border-zinc-600 bg-zinc-800",
    active: "border-neon bg-neon shadow-[0_0_16px_rgba(0,255,102,0.5)]",
    goal: "border-cyber bg-cyber shadow-[0_0_16px_rgba(0,240,255,0.5)]",
};

const TEXT_STYLES = {
    past: "text-zinc-500",
    active: "text-neon",
    goal: "text-cyber",
};

export const Timeline = () => (
    <section id="timeline" data-testid="timeline-section" className="scroll-mt-20 border-t border-white/5 bg-surface/30 py-24 md:py-32">
        <div className="mx-auto max-w-7xl px-5 sm:px-8">
            <SectionHeader
                chapter="08"
                kicker="Trajectory"
                title="Career Timeline"
                testId="timeline-heading"
            />

            <div className="relative ml-3 border-l border-white/10 pl-10 md:ml-6 md:pl-14">
                {TIMELINE.map((item, i) => (
                    <Reveal key={item.title} delay={i * 0.1} className="relative pb-14 last:pb-0">
                        <span
                            aria-hidden="true"
                            className={`absolute -left-[45px] top-1.5 h-3.5 w-3.5 rounded-full border-2 md:-left-[61px] ${NODE_STYLES[item.state]}`}
                        />
                        <p className={`font-mono2 text-xs uppercase tracking-[0.25em] ${TEXT_STYLES[item.state]}`}>
                            {item.period}
                        </p>
                        <h3 className="mt-2 flex items-center gap-3 font-display text-xl font-extrabold tracking-tight text-zinc-100 sm:text-2xl">
                            {item.title}
                            {item.state === "goal" && (
                                <Flag size={16} strokeWidth={1.5} className="text-cyber" />
                            )}
                        </h3>
                        <p className="mt-3 max-w-2xl text-sm leading-relaxed text-zinc-400 md:text-base">
                            {item.text}
                        </p>
                    </Reveal>
                ))}
            </div>
        </div>
    </section>
);
